module.exports = __webpack_public_path__ + "resources/img/img_txtlogo_makeit_2x_m.eecadc342f8a57d27bee6929b5769365.png";